/*** IMPORTS FROM imports-loader ***/
var define = false;

export function initScrollAnimations() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Fade-in animations via Intersection Observer
  const animateElements = document.querySelectorAll('.animateOnLoad');

  if (prefersReducedMotion) {
    // Respect reduced motion: show everything immediately
    animateElements.forEach(el => el.classList.add('inView'));
    return;
  }

  if (animateElements.length) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('inView');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    animateElements.forEach(el => observer.observe(el));
  }

  // Parallax via scroll listener (desktop only)
  const isDesktop = window.matchMedia('(min-width: 960px)');
  const parallaxElements = document.querySelectorAll('.parallax');

  if (!parallaxElements.length) return;

  let ticking = false;

  function updateParallax() {
    if (!isDesktop.matches) {
      // Reset transforms on mobile
      parallaxElements.forEach(el => { el.style.transform = ''; });
      ticking = false;
      return;
    }

    const viewportHeight = window.innerHeight;
    const viewportCenter = viewportHeight / 2;

    parallaxElements.forEach(el => {
      const rect = el.getBoundingClientRect();
      const elementCenter = rect.top + rect.height / 2;
      const distanceFromCenter = elementCenter - viewportCenter;

      // Determine speed multiplier from class
      let speed = 0.05;
      if (el.classList.contains('parallax--slow')) speed = 0.025;
      else if (el.classList.contains('parallax--fast')) speed = 0.1;

      // Calculate offset capped at ±40px
      let offset = distanceFromCenter * speed;
      offset = Math.max(-40, Math.min(40, offset));

      el.style.transform = `translateY(${offset}px)`;
    });

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  // Initial position
  updateParallax();
}

